
import { makeAutoObservable } from 'mobx';

class App {
  showContactModal = false;
  constructor() {
    makeAutoObservable(this);
  }
  openContactModal = () => {
    this.showContactModal = true;
  }
  closeContactModal = () => {
    this.showContactModal = false;
  }

}

export default new App();
